console.log("JS estimated-delivery-custom.js loaded!");

document.addEventListener('DOMContentLoaded', function() {
  console.log("DOMContentLoaded fired");

  const app = document.getElementById('estimated-delivery-app');
  if (!app) return;

  const warehouseZip = app.dataset.warehouseZip || '';
  const cutoffTime = app.dataset.cutoff || '12:00'; // Default to 12 PM Eastern
  const leadToShip = parseInt(app.dataset.lead, 10) || 0;

  const edLocationLine = app.querySelector('#ed-location-line');
  const edOrderLine = app.querySelector('#ed-order-line');
  const edDeliveryLine = app.querySelector('#ed-delivery-line');
  const edShippingMethodLine = app.querySelector('#ed-shipping-method-line'); // NEW
  const edForm = app.querySelector('#ed-zip-form');
  const edInput = app.querySelector('#ed-zip-input');
  const edError = app.querySelector('#ed-error-message');
  

  let clientZip = window.localStorage.getItem('ed_zip') || '';
  let formOpen = false;

  // USPS Ground Advantage estimated transit days by region
  const stateTransitDays = {
    // Local/regional (2–3 business days)
    NJ:2, NY:2, CT:2, PA:2, MD:2, DE:2, MA:2, RI:2,
    // Nearby mid‑range (3–4 business days)
    VA:3, OH:3, MI:3, IL:3, WI:3, NC:3, SC:3, GA:3, FL:3,
    // Farther cross‑country (4–5 business days)
    TX:4, CO:4, AZ:4, WA:5, OR:5, CA:5,
    // Longest/remote areas
    AK:7, HI:7
  };

  function getCustomerZip() {
    try {
      if (window.Shopify &&
          Shopify.customer &&
          Shopify.customer.default_address &&
          Shopify.customer.default_address.zip) {
        return Shopify.customer.default_address.zip;
      }
    } catch (e) {}
    return '';
  }

  function getMinutesUntilNextCutoff(cutoff) {
    const now = new Date();
    const estOffset = -5;
    const estNow = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (estOffset * 3600000));
    const [h, m] = cutoff.split(':').map(Number);
    let c = new Date(estNow);
    c.setHours(h, m, 0, 0);
    if (estNow < c) return Math.floor((c - estNow) / 1000 / 60);
    let nxt = new Date(estNow);
    nxt.setDate(nxt.getDate() + 1);
    nxt.setHours(h, m, 0, 0);
    return Math.floor((nxt - estNow) / 1000 / 60);
  }

  function getShipDate(cutoff) {
    const now = new Date();
    const estOffset = -5;
    const estNow = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (estOffset * 3600000));
    const [h, m] = cutoff.split(':').map(Number);
    let ship = new Date(estNow);
    if (estNow.getHours() > h || (estNow.getHours() === h && estNow.getMinutes() >= m)) {
      ship.setDate(ship.getDate() + 1);
    }
    while (ship.getDay() === 0 || ship.getDay() === 6) {
      ship.setDate(ship.getDate() + 1);
    }
    return ship;
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added++;
    }
    return result;
  }

  function renderOrderWithin() {
    const now = new Date();
    const dow = now.getDay();
    if (dow === 0 || dow === 6) {
      edOrderLine.innerHTML = `Ships <strong style="color:#407F32;">Monday</strong>`;
      return;
    }
    const mins = getMinutesUntilNextCutoff(cutoffTime);
    if (mins <= 0) {
      edOrderLine.innerHTML = '';
      return;
    }
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    edOrderLine.innerHTML =
      `Order within <strong style="color:#407F32;">${h} hrs ${m} mins</strong> to ship same day.`;
  }

  async function fetchLocationByZip(zip) {
    try {
      const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
      if (!res.ok) return { city:'', state:'' };
      const data = await res.json();
      return data && data.places && data.places.length ? {
        city: data.places[0]['place name'],
        state: data.places[0]['state abbreviation']
      } : { city:'', state:'' };
    } catch {
      return { city:'', state:'' };
    }
  }

  function showLocation(zip, city) {
    edLocationLine.innerHTML = `
      <a href="#" id="ed-location-link">
        ${ city ? `${city} — ${zip}` : zip }
      </a>
    `;
    document.getElementById('ed-location-link').onclick = e => {
      e.preventDefault();
      formOpen = !formOpen;
      edForm.classList.toggle('hidden-zip', !formOpen);
      showLocation(zip, city);
    };
    if (!formOpen) edForm.classList.add('hidden-zip');
    edInput.value = zip;
  }

  async function render() {
    edError.textContent = '';
    renderOrderWithin();

    const shopZip = getCustomerZip();
    let zip = clientZip || shopZip;

    if (zip) {
      const { city, state } = await fetchLocationByZip(zip);
      showLocation(zip, city);

      const transitDays = stateTransitDays[state] || 4; // fallback to ~4‑5
      const shipDate = getShipDate(cutoffTime);
      const deliverDate = addBusinessDays(shipDate, transitDays + leadToShip);

      // let deliveryText;
      // const today = new Date();
      // const oneDayMs = 24 * 60 * 60 * 1000;
      // if (deliverDate - today >= oneDayMs && deliverDate - today < 2 * oneDayMs) {
      //   deliveryText = 'Tomorrow';
      // } else {
      //   deliveryText = deliverDate.toLocaleDateString('en-US', {
      //     weekday:'short',
      //     month:'short',
      //     day:'numeric'
      //   });
      // }
      //code above is buggy wil return one day to early
      let deliveryText;

const todayDate = new Date();
todayDate.setHours(0,0,0,0);

const tomorrow = new Date(todayDate);
tomorrow.setDate(tomorrow.getDate() + 1);

const deliverCompare = new Date(deliverDate);
deliverCompare.setHours(0,0,0,0);

if (deliverCompare.getTime() === tomorrow.getTime()) {
  deliveryText = 'Tomorrow';
} else {
  deliveryText = deliverDate.toLocaleDateString('en-US', {
    weekday:'short',
    month:'short',
    day:'numeric'
  });
}

      edDeliveryLine.innerHTML = `<span class="ed-delivery-line-text">Deliver by <strong>${deliveryText}</strong></span>`;
     

      // NEW: Show shipping method info
if (edShippingMethodLine) {
  edShippingMethodLine.innerHTML = `<span style="font-size:0.9em; color:#555;">
Ships via USPS Ground Advantage. Express available.
</span>`;
}

      formOpen = false;
      edForm.classList.add('hidden-zip');
    } else {
      edLocationLine.innerHTML = '<span>Please enter your ZIP code</span>';
      edDeliveryLine.textContent = '';
      edShippingMethodLine.textContent = '';
      edForm.classList.remove('hidden-zip');
      edInput.value = '';
      formOpen = true;
    }
  }

  if (!clientZip) {
    fetch('https://ipapi.co/json/')
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        const geoZip = data.postal;
        if (/^[0-9]{5}$/.test(geoZip)) {
          clientZip = geoZip;
          localStorage.setItem('ed_zip', geoZip);
          formOpen = false;
          edForm.classList.add('hidden-zip');
          render();
        }
      }).catch(() => console.warn('Could not get ZIP via IPAPI'));
  }

  edForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const val = edInput.value.trim();
    if (/^[0-9]{5}$/.test(val)) {
      edError.textContent = '';
      clientZip = val;
      localStorage.setItem('ed_zip', val);
      formOpen = false;
      render();
    } else {
      edError.textContent = 'Please enter a valid ZIP code.';
      edInput.style.borderColor = '#E25C59';
      edInput.focus();
    }
  });

  render();
  window.addEventListener('resize', render);
});
